export default __webpack_public_path__ + "static/media/login.b0279d8c.png";